/*
 * @Author: your name
 * @Date: 2021-08-04 11:21:32
 * @LastEditTime: 2021-08-23 08:49:49
 * @LastEditors: Please set LastEditors
 * @Description: 新版新建运单api文件
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\waybillAddNew.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BUSI_WEB } = e6ModuleOrderWaybillProcessApi;

//获取唯一运单号
export function fetchWaybillNo() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillNo`,
    method: "get"
  });
}
//运单号唯一性校验
export function validWaybillNo(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/waybillNo/repeat`,
    method: "get",
    params
  });
}
// 查询业务模式配置
export function fetchBusiTypeConfig() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getWaybillBusinessType`,
    method: "get"
  });
}
//查询订单业务类型
export function fetchOrderBusiType() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/flowBusinessType/getUsedBusinessTypeList`,
    method: "get"
  });
}
// 保存新增运单
export function saveAddWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/saveOrEdit`,
    method: "post",
    data
  });
}
//点击复制查询详情接口
export function fetchCopyDeatilInfo(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/copyWaybill`,
    method: "get",
    params
  });
}
